<template>
    <div class="autos">
        <div class="title">
            <span>Seguros</span>
            <h1>Personales y Familia</h1>
            <div id="contactForm">
                <label for="">Conoce más sobre soluciones de seguros</label>
                <div id="hubcontactForm"></div>
            </div>
        </div>
        <div class="info">
                <h1>Seguro de Motos:</h1>
                <h1>Muévete seguro y con independencia</h1>
                <p>Si te desplazas en moto porque así te mueves con más facilidad e independencia, o porque trabajas en ella
                en servicios a domicilio o de mensajería, este plan es para ti.</p>
        </div>
        <div class="img">
            <center>
                <img src="@/assets/seguro-motos/img-seguridad-vial-moto.png" alt="">
            </center>
        </div>
        <div class="texto">
            <center class="box">
                <p>Aseguramos motos de alto cilindraje (mayor a 250 c.c) y bajo cilindraje (menor o igual a 250 c.c.). Para cuidar la tuya, cuentas con
                tres revisiones preventivas gratis al año y las asesorías que necesites con un mecánico experto. Esto se brinda en el Centro de Servicios
                Motos y sus aliados o, si prefieres, de forma virtual, También tienes un peritaje gratuito. Si estás de viaje en carretera y te chocas o varas y tu
                moto es de alto cilindraje, tienes servicio de grúa de amplio alcance para devolverte o llegar a tu destino. Esto también aplica si tu moto es
                eléctrica.</p>
            </center>
        </div>
        <Aliados/>
    </div>
</template>

<script>
import Aliados from '../../utilitis/aliados'

export default {
    name: 'Seguro-Colectivo-salud',
    components: {
        Aliados
    },
    data() {
        return {
        }
    },
    beforeMount() {
        this.$root.$emit('change_url', this.$route.name)
    },
    mounted() {
        window.hbspt.forms.create({
            region: 'na1',
            portalId: '5573496',
            formId: '4cd61e34-58c1-4068-accb-dae3eeb5e789',
            target: '#hubcontactForm'
        })
    }
}
</script>

<style scoped>
.title {
    background-image: url('../../../assets/servicios-bg-personas-familias.png');
    padding: 200px 200px;
    color: #fff;
    background-position: center;
    background-repeat: no-repeat;
}
.title > span {
    font-family: 'JLI';
    font-size: 40px;
}
.title > h1 {
    font-family: 'JBD';
    font-size: 50px;
}
#contactForm {
    margin-top: -100px;
    font-family: 'JR';
    background-color: #fff;
    padding: 40px;
    position: absolute;
    border-radius: 10px;
    width: 400px;
    -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
    -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
    box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
    font-weight: bolder;
    right: 100px;
}
#contactForm > label {
    color: #65b24a;
    font-size: 24px;
    line-height: 25px;
}
.info {
    padding: 100px 0px;
}
.info > h1 {
    font-family: 'JBD';
    color: #65b24a;
    padding-left: 200px;
    font-size: 50px;
}
.info > p {
    font-family: 'JR';
    width: 60%;
    padding-left: 200px;
    margin-top: 10px;
    font-size: 18px;
}

.img > center > img {
    width: 70%;
}
.texto {
    width: 100%;
    padding: 10px 200px;
}
.texto > center > h1 {
    color: #2d4f98;
    font-family: 'JBD';
}
.texto > .box-title {
    margin-top: 50px;
    margin-bottom: 50px;
}
.texto > .box-title > h1 {
    color: #2d4f98;
    font-family: 'JBD';
}
.texto > .box {
    padding: 20px 20px;
    text-align: left;
    -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
    -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
    box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
    margin-bottom: 10px;
}
.texto > center > label {
    font-family: 'JBD';
    color: #65b24a;
}
.texto > center > p {
    font-family: 'JR';
}
.texto > center > p > span{
    font-weight: bold;
    color: #2d4f98;
}
@media (max-width: 1500px) {
    .title {
        padding: 200px 200px;
    }
    .info > h1 {
        padding-left: 200px;
    }
    .info > p {
        padding-left: 200px;
    }
}
@media (max-width: 1400px) {
    .title {
        padding: 200px 100px;
    }
    .info > h1 {
        padding-left: 100px;
        font-size: 30px;
    }
    .info > p {
        padding-left: 100px;
    }
}
@media (max-width: 1300px) {
    .info > h1 {
        font-size: 30px;
    }
    .info > p {
        width: 50%;
    }
    .texto {
        width: 100%;
        padding: 10px 200px;
    }
}
@media (max-width: 1100px) {
    #contactForm {
        margin-top: -100px;
        right: 50px;
    }
}
@media (max-width: 1000px) {
    .title {
        padding: 50px 0px;
        height: 400px;
        text-align: center;
    }
    #contactForm {
        margin-top: 10px;
        left: 0;
        right: 0;
        margin: auto;
    }
    .info {
        padding-top: 400px;
        width: 100%;
        text-align: center;
    }
    .info > h1 {
        width: 100%;
        padding: 10px;
        text-align: center;
    }
    .info > p {
        width: 100%;
        text-align: center;
        padding: 10px;
    }
    .texto {
        width: 100%;
        padding: 10px 100px;
    }
}
@media (max-width: 700px) {
    .texto {
        width: 100%;
        padding: 10px 50px;
    }
}
@media (max-width: 500px) {
    .texto > .box-title > h1 {
        font-size: 30px;
    }
    #contactForm {
        width: 300px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Servicios/ServiciosPersonas/SeguroMotos.vue